import { confluenceLocalStorageInstance } from '@confluence/storage-manager/entry-points/storageInstance';
import { PERSISTED_KEYS_ON_SERVER } from '@confluence/storage-manager/entry-points/LocalStorageKeys';
import { fg } from '@confluence/feature-gating';

/**
 * Retrieves the persisted ghost text for QuickFind search input.
 * Prioritizes DOM value (from SSR) over localStorage to preserve hydration consistency.
 *
 * @returns The ghost text string or undefined if not available
 */
export const getPersistedGhostText = (): string | undefined => {
	if (!fg('quickfind-ghosttext')) {
		return undefined;
	}

	// Priority 1: Try to read from the DOM element (preserves SSR'd value)
	let ghostText: string | undefined;
	try {
		const searchInput = document.querySelector('[data-testid="search-input"]');
		if (searchInput instanceof HTMLInputElement && searchInput?.placeholder) {
			ghostText = searchInput.placeholder;
		}
	} catch (e) {
		// Ignore - DOM might not be available during SSR or element not found yet
	}

	// If found in DOM and valid, use it
	if (ghostText && ghostText.length > 0) {
		return ghostText;
	}

	// Priority 2: Fall back to reading from localStorage
	return confluenceLocalStorageInstance.getItem(
		PERSISTED_KEYS_ON_SERVER.PERSISTED_PLATFORM_QUICKFIND_GHOSTTEST,
	);
};
